import { render, staticRenderFns } from "./verificate.vue?vue&type=template&id=6c7244d8&"
import script from "./verificate.vue?vue&type=script&lang=js&"
export * from "./verificate.vue?vue&type=script&lang=js&"
import style0 from "./verificate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports